const EstadosLoteEnum = {
  Apartado: 1,
  Disponible: 2,
  Suspendido: 3,
  Vendido: 4,
}

export default EstadosLoteEnum;
